import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ProductPage from '../components/ProductPage';
import { dalcommAccessoryBySlug } from '../data/dalcomm';

/**
 * Dynamic sub-product page for every Dalcomm GSE accessory.
 * Route: /products/dalcomm/gse-adapters/:slug
 *
 * Each entry in `data/dalcomm.js -> dalcommGseAccessories` becomes a
 * dedicated crawlable product page that renders through the shared
 * ProductPage template used across the rest of the catalog.
 */
const DalcommGSEAccessoryPage = ({ onRequestDemo, onRequestQuote }) => {
  const { slug } = useParams();
  const accessory = dalcommAccessoryBySlug(slug);

  if (!accessory) return <Navigate to="/products/dalcomm/gse-adapters" replace />;

  // Normalize the accessory data into the shape ProductPage expects.
  // Features are shipped from the data file as bare strings — wrap them into
  // { title, description } so the shared template's feature grid renders.
  const features = (accessory.features || []).map((f, i) => {
    if (typeof f === 'string') {
      // Use everything before the first en/em dash / colon as the title,
      // fall back to the whole string.
      const split = f.split(/\s—\s|\s–\s|:\s/);
      if (split.length > 1) {
        return { title: split[0].trim(), description: split.slice(1).join(' — ').trim() };
      }
      return { title: `Feature ${i + 1}`, description: f };
    }
    return f;
  });

  const productData = {
    productName: accessory.name,
    partNumber: `DALCOMM-${accessory.slug.toUpperCase()}`,
    tagline: accessory.tagline,
    description: accessory.description,
    image: accessory.image,
    images: accessory.images && accessory.images.length ? accessory.images : [accessory.image],
    imageContain: true,
    features,
    specifications: accessory.price
      ? [{ label: 'Price', value: accessory.price }]
      : [],
    applications: [],
  };

  return (
    <ProductPage
      {...productData}
      onRequestDemo={onRequestDemo}
      onRequestQuote={onRequestQuote}
    />
  );
};

export default DalcommGSEAccessoryPage;
